import type { WidgetConfig } from "../lib/types.ts";
import { Avatar } from "./Header.tsx";
import styles from "./Welcome.module.css";

interface Props {
  config: WidgetConfig;
  /** Questions about the page the visitor reads (a flat, an investment); the tenant's own otherwise. */
  pageSuggestions?: string[] | null;
  onPick(text: string, index: number, fromPage: boolean): void;
  disabled: boolean;
}

export function Welcome({ config, pageSuggestions, onPick, disabled }: Props) {
  const welcome =
    config.widget.welcomeMessage?.trim() ||
    (config.mode === "shop" ? "Dzień dobry! Pomogę znaleźć produkt i sprawdzić dostępność." : "Dzień dobry! Pomogę znaleźć mieszkanie z naszej oferty.");
  const fromPage = Boolean(pageSuggestions?.length);
  const suggestions = ((fromPage ? pageSuggestions : config.widget.suggestions) ?? []).filter((s) => s.trim());
  return (
    <div class={styles.welcome}>
      <Avatar config={config} size="lg" />
      <p class={styles.message}>{welcome}</p>
      {suggestions.length > 0 && (
        <div class={styles.suggestions} role="group" aria-label="Przykładowe pytania">
          {suggestions.map((text, i) => (
            <button key={text} type="button" class={styles.chip} style={{ "--i": i }} disabled={disabled} onClick={() => onPick(text, i, fromPage)}>
              {text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
